import { Route, Routes } from "react-router-dom";
import CustomerSalesReportPage from "./CustomerSalesReportPage";
import SalesReportPage from "./SalesReportPage";

const SalesReportRoutes = () => {
  return (
    <Routes>
      <Route index element={<SalesReportPage />} />
      <Route path=":partnerId" element={<CustomerSalesReportPage />} />
    </Routes>
  );
};

export default SalesReportRoutes;
